<template>
  <v-dialog v-model="dialogModel" width="900">
    <v-card class="bg-white pl-4 pr-0 py-4 ai-data-dialog d-flex flex-column">
      <v-card class="mb-6 mr-6 d-flex align-center py-2 ai-tip-card" flat>
        <svg class="ml-2 mr-4" width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_146888_2680)">
              <path d="M2.5 11C2.5 5.75329 6.75329 1.5 12 1.5H40C45.2467 1.5 49.5 5.75329 49.5 11V39C49.5 44.2467 45.2467 48.5 40 48.5H12C6.75329 48.5 2.5 44.2467 2.5 39V11Z" stroke="#EAECF0" shape-rendering="crispEdges"/>
              <g clip-path="url(#clip0_146888_2680)">
                <path d="M25.4867 22.3712C25.6517 21.8762 26.3507 21.8762 26.5157 22.3712L27.4832 25.2767C27.6961 25.9154 28.0549 26.4957 28.5311 26.9717C29.0073 27.4476 29.5879 27.8061 30.2267 28.0187L33.1307 28.9862C33.6257 29.1512 33.6257 29.8502 33.1307 30.0152L30.2252 30.9827C29.5865 31.1956 29.0062 31.5544 28.5302 32.0306C28.0543 32.5068 27.6958 33.0874 27.4832 33.7262L26.5157 36.6302C26.4801 36.7386 26.4112 36.833 26.3188 36.8999C26.2264 36.9668 26.1153 37.0028 26.0012 37.0028C25.8871 37.0028 25.7759 36.9668 25.6835 36.8999C25.5912 36.833 25.5223 36.7386 25.4867 36.6302L24.5192 33.7247C24.3064 33.0861 23.9478 32.5059 23.4719 32.03C22.9959 31.5541 22.4157 31.1955 21.7772 30.9827L18.8717 30.0152C18.7633 29.9796 18.6689 29.9107 18.602 29.8183C18.5351 29.7259 18.499 29.6148 18.499 29.5007C18.499 29.3866 18.5351 29.2754 18.602 29.183C18.6689 29.0907 18.7633 29.0218 18.8717 28.9862L21.7772 28.0187C22.4157 27.8059 22.9959 27.4473 23.4719 26.9714C23.9478 26.4954 24.3064 25.9152 24.5192 25.2767L25.4867 22.3712ZM19.6922 14.7227C19.7137 14.6577 19.7551 14.6012 19.8106 14.5611C19.8661 14.5211 19.9328 14.4995 20.0012 14.4995C20.0696 14.4995 20.1363 14.5211 20.1918 14.5611C20.2472 14.6012 20.2887 14.6577 20.3102 14.7227L20.8907 16.4657C21.1502 17.2427 21.7592 17.8517 22.5362 18.1112L24.2792 18.6917C24.3441 18.7132 24.4007 18.7546 24.4407 18.8101C24.4808 18.8656 24.5024 18.9323 24.5024 19.0007C24.5024 19.0691 24.4808 19.1358 24.4407 19.1913C24.4007 19.2467 24.3441 19.2882 24.2792 19.3097L22.5362 19.8902C22.1527 20.0174 21.8043 20.2325 21.5186 20.5181C21.233 20.8038 21.0179 21.1522 20.8907 21.5357L20.3102 23.2787C20.2887 23.3436 20.2472 23.4002 20.1918 23.4402C20.1363 23.4803 20.0696 23.5019 20.0012 23.5019C19.9328 23.5019 19.8661 23.4803 19.8106 23.4402C19.7551 23.4002 19.7137 23.3436 19.6922 23.2787L19.1117 21.5357C18.9844 21.1522 18.7694 20.8038 18.4837 20.5181C18.198 20.2325 17.8496 20.0174 17.4662 19.8902L15.7232 19.3097C15.6582 19.2882 15.6017 19.2467 15.5616 19.1913C15.5216 19.1358 15.5 19.0691 15.5 19.0007C15.5 18.9323 15.5216 18.8656 15.5616 18.8101C15.6017 18.7546 15.6582 18.7132 15.7232 18.6917L17.4662 18.1112C17.8496 17.9839 18.198 17.7689 18.4837 17.4832C18.7694 17.1976 18.9844 16.8491 19.1117 16.4657L19.6922 14.7227ZM30.2957 13.1492C30.3105 13.1065 30.3382 13.0694 30.3751 13.0432C30.4119 13.017 30.456 13.0029 30.5012 13.0029C30.5464 13.0029 30.5905 13.017 30.6273 13.0432C30.6641 13.0694 30.6919 13.1065 30.7067 13.1492L31.0937 14.3102C31.2662 14.8292 31.6727 15.2357 32.1917 15.4082L33.3527 15.7952C33.3954 15.81 33.4324 15.8377 33.4586 15.8746C33.4848 15.9114 33.4989 15.9555 33.4989 16.0007C33.4989 16.0459 33.4848 16.09 33.4586 16.1268C33.4324 16.1636 33.3954 16.1914 33.3527 16.2062L32.1917 16.5932C31.9361 16.6787 31.7039 16.8224 31.5134 17.0129C31.3229 17.2034 31.1792 17.4356 31.0937 17.6912L30.7067 18.8522C30.6919 18.8949 30.6641 18.9319 30.6273 18.9581C30.5905 18.9844 30.5464 18.9984 30.5012 18.9984C30.456 18.9984 30.4119 18.9844 30.3751 18.9581C30.3382 18.9319 30.3105 18.8949 30.2957 18.8522L29.9087 17.6912C29.8232 17.4356 29.6795 17.2034 29.489 17.0129C29.2984 16.8224 29.0662 16.6787 28.8107 16.5932L27.6512 16.2062C27.6085 16.1914 27.5714 16.1636 27.5452 16.1268C27.519 16.09 27.5049 16.0459 27.5049 16.0007C27.5049 15.9555 27.519 15.9114 27.5452 15.8746C27.5714 15.8377 27.6085 15.81 27.6512 15.7952L28.8122 15.4082C29.3312 15.2357 29.7377 14.8292 29.9102 14.3102L30.2957 13.1492Z" fill="#7F56D9"/>
              </g>
            </g>
            <defs>
              <filter id="filter0_d_146888_2680" x="0" y="0" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="1"/>
                <feGaussianBlur stdDeviation="1"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_146888_2680"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_146888_2680" result="shape"/>
              </filter>
              <clipPath id="clip0_146888_2680">
                <rect width="24" height="24" fill="white" transform="translate(14 13)"/>
              </clipPath>
            </defs>
          </svg>
        <div class="d-flex flex-column flex-grow-1">
          <span class="ai-tip-title">AI Suggested Instructions</span>
        </div>
        <div class="d-flex">
          <v-btn
              icon
              color="grey"
              @click="emit('update:show', false)"
              class="mr-2"
          >
            <Icon class="cursor-pointer" name="popup_close"></Icon>
          </v-btn>
        </div>
      </v-card>
      <v-card
        outlined
        class="flex-grow-1 ai-dialog-scrolling-container"
      >
        <div
          class="ai-dialog-scrolling-container-instructions"
          style="height: 180px"
          v-if="instructions"
        >
          <div v-html="instructions">
          </div>
        </div>
      </v-card>
      <div class="d-flex mr-4 mt-8">
        <Button
            style="width: 66px; padding: 0;"
            class="mr-3"
            label="Skip"
            outline="outline-active"
            @onClick="$emit('onSkip')"
        ></Button>
        <Button
            style="width: auto;"
            class="flex-grow-1"
            label="Add instructions"
            normal="normal-active"
            @onClick="$emit('onAddInstructions')"
        ></Button>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
</script>
<script setup>
import { computed, ref, onMounted, watch } from "vue";
import Button from "@components/buttons/Button.vue";
import Icon from "@components/icons/Icon.vue";
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  instructions: {
    type: String,
    default: `To determine if an employee can create tasks in Notion, an inspector should inspect the following:
              Workspace Permissions
              Check if the user has edit or full access to the relevant page or database.
              In Notion, only users with edit-level permissions or higher can create or modify tasks.
              Database Access
              Confirm the employee has access to the task database (e.g. a Kanban board, table, or list).
              Check if they can add new entries to that database.
              Page Sharing Settings
              See if the employee is added directly or via a team/group with permissions.
              Check if the page or database is locked or restricted.
              Role or Team Group Permissions
              Inspect the team role (if using Notion Teams/Enterprise) to verify what rights are inherited.
              Admin/Owner Restrictions
              Determine if any admins have set granular restrictions that prevent task creation.`
  }
});

const emit = defineEmits(["update:show", "update:selected", "saveAIData"]);

const dialogModel = computed({
  get: () => props.show,
  set: (value) => {
    emit("update:show", value);
  }
});

const selectedParents = ref([]);

const selectedChildren = ref([]);

const selectedItems = computed(() => {
  const result = [];

  props.aiData.forEach((item, parentIndex) => {
    if (parentIndex < selectedParents.value.length && parentIndex < selectedChildren.value.length) {
      if (selectedParents.value[parentIndex]) {
        const selectedChildItems = item.checklist.filter((childItem, childIndex) =>
            selectedChildren.value[parentIndex] && childIndex < selectedChildren.value[parentIndex].length && selectedChildren.value[parentIndex][childIndex]
        );

        if (selectedChildItems.length > 0) {
          result.push({
            name: item.name,
            checklist: selectedChildItems
          });
        }
      }
    }
  });

  return result;
});

const initializeSelections = () => {
  // selectedParents.value = props.aiData.map(() => true);
  // selectedChildren.value = props.aiData.map(item =>
  //     item.checklist.map(() => true)
  // );
  // emit("update:selected", selectedItems.value);
};

onMounted(() => {
  initializeSelections();
});

// watch(() => props.aiData, () => {
//   initializeSelections();
// }, { deep: true });
</script>

<style scoped>
.ai-data-dialog {
  border-radius: 12px;
}
.ai-tip-card {
  flex-shrink: 0;
}
.ai-dialog-scrolling-container {
  flex: 1;
  overflow-y: auto;
  margin-right: 32px;
  margin-left: 16px;
}
.ai-dialog-scrolling-container::-webkit-scrollbar {
  width: 24px;
}

.ai-dialog-scrolling-container::-webkit-scrollbar-track {
  background-color: transparent !important;
}

.ai-dialog-scrolling-container::-webkit-scrollbar-thumb {
  background-color: #EAECF0;
  border-radius: 10px;
  border: 8px solid transparent;
  background-clip: content-box;
}

.ai-dialog-scrolling-container::-webkit-scrollbar-button {
  display: none !important;
}

.ai-tip-title {
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #101828;
}
.ai-tip-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #666666;
}
.ai-item .item-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  white-space: nowrap;
  color: #344054;
}
.ai-item .item-checkpoint {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #475467;
}

.custom-checkbox-size >>> .v-input--selection-controls__input .v-icon {
  width: 20px;
  height: 20px;
}
.custom-checkbox-size >>> .v-input--selection-controls__ripple {
  width: 28px;
  height: 28px;
  top: calc(50% - 14px);
  left: calc(50% - 23px);
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}

.ai-dialog-scrolling-container-instructions { 
  padding: 0px 15px;
}
</style>
